import Tooltip from '../../../../../../common/_custom/Tooltip/Tooltip';
import EntityHoverCard from './EntityHoverCard';
import { toEntityHoverProfile, type EntityHoverRow } from './toEntityHoverProfile';
import type { EntityHoverProfile } from './EntityHoverCard.types';
import styles from './EntityHoverCard.module.scss';
import { HOVER_CARD_TOOLTIP_PROPS } from '../hoverCardTooltip.constants';

type EntityHoverCardTooltipProps = ({ row: EntityHoverRow; profile?: never } | { profile: EntityHoverProfile; row?: never }) & {
    children: React.ReactNode;
};

const CARD_CONTENT_CSS = { padding: 0, background: 'transparent', boxShadow: 'none', borderRadius: '0.5rem' };

/** Builds the profile only when the tooltip mounts its content, i.e. on hover. */
function EntityHoverCardContent({ row }: { row: EntityHoverRow }) {
    return <EntityHoverCard profile={toEntityHoverProfile(row)} />;
}

/** Mounts the company/LLP hover card on a Related Party name cell: built from the row's entity data, or from a ready profile such as the no-data card. */
function EntityHoverCardTooltip({ children, ...source }: EntityHoverCardTooltipProps) {
    return (
        <Tooltip
            {...HOVER_CARD_TOOLTIP_PROPS}
            content={source.profile ? <EntityHoverCard profile={source.profile} /> : <EntityHoverCardContent row={source.row} />}
            contentCss={CARD_CONTENT_CSS}
            flipToFit
            keepInScrollContainer
            verticalAlign="center"
            tipClassName={styles.HoverCardTip}
        >
            {children}
        </Tooltip>
    );
}

export default EntityHoverCardTooltip;
